import type { HideButtonProps } from "./HideButton.type";

import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import "./HideButton.style.less";

const HideButton = ({
  disabled = false,
  saliencyMapIsVisible = false,
  onClick,
}: HideButtonProps) => {
  const { t } = useTranslation();
  return (
    <div className="decision-tool-hide-button">
      <Button data-testid="hide-button" onClick={onClick} disabled={disabled}>
        {saliencyMapIsVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        {saliencyMapIsVisible
          ? t("form:staticField.defectSuggestion.hideSaliencyMap")
          : t("form:staticField.defectSuggestion.showSaliencyMap")}
      </Button>
    </div>
  );
};

export default HideButton;
